import angular from 'angular'
import template from './index.html'

const etPaginationModule = angular.module('app.etPagination', [])

export default etPaginationModule.name

etPaginationModule.directive('etPagination', () => ({
  template,
  restrict: 'AE',
  replace: true,
  scope: {
    itemsPerPage: '=',
    totalItems: '<',
    ngModel: '=',
    maxSize: '@',
    ngChange: '&',
    perpageSelect: '@', // 是否显示页数选择器和跳转
    profileType: '<', // 用户习惯表ID
  },
  controller: [
    '$scope',
    'httpRequest',
    function ctrl($scope, httpRequest) {
      $scope.totalItems = $scope.totalItems ? $scope.totalItems : 100
      $scope.maxSize = $scope.maxSize || 10
      $scope.pageAddon = {
        pageModel: '',
        itemsPerPage: $scope.itemsPerPage || 10,
      }
      function loadSavedConfig(profileType) {
        if (profileType == null) return
        httpRequest.get_getUserCustomized(profileType).then((res) => {
          if (res.data.value) {
            const itemsPerPage = JSON.parse(res.data.value).pageSize
            if (itemsPerPage && itemsPerPage != $scope.pageAddon.itemsPerPage) {
              $scope.pageAddon.itemsPerPage = itemsPerPage
            }
            if (itemsPerPage && itemsPerPage != $scope.itemsPerPage) {
              $scope.itemsPerPage = itemsPerPage
              setTimeout(() => {
                $scope.ngChange && $scope.ngChange()
              })
            }
          }
        })
      }
      loadSavedConfig($scope.profileType)
      // 适配tab
      $scope.$watch('profileType', (newVal, oldValue) => {
        if (oldValue === newVal) {
          return
        }
        $scope.profileType = newVal
        loadSavedConfig($scope.profileType)
      })
      $scope.perpageList = [
        {
          text: '10条',
          id: 10,
        },
        {
          text: '20条',
          id: 20,
        },
        {
          text: '30条',
          id: 30,
        },
        {
          text: '50条',
          id: 50,
        },
        {
          text: '100条',
          id: 100,
        },
        {
          text: '200条',
          id: 200,
        },
      ]
      if (
        $scope.itemsPerPage != 10 &&
        $scope.itemsPerPage != 20 &&
        $scope.itemsPerPage != 30 &&
        $scope.itemsPerPage != 50 &&
        $scope.itemsPerPage != 100 &&
        $scope.itemsPerPage != 200 &&
        $scope.itemsPerPage
      ) {
        $scope.perpageList.unshift({
          text: `${$scope.itemsPerPage}条`,
          id: $scope.itemsPerPage,
        })
      }
      // 是否显示页数选择器和跳转
      if (
        $scope.perpageSelect === undefined ||
        $scope.perpageSelect === 'true'
      ) {
        $scope.perpageSelect = true
      } else {
        $scope.perpageSelect = false
      }
      // 规范要求不设置初始值
      // $scope.pageModel = $scope.ngModel
      $scope.pageModelChange = function pageModelChange() {
        let { pageModel } = $scope.pageAddon
        if (pageModel === $scope.ngModel || !pageModel) {
          return
        }
        // 输入大于最大页数 跳转到最大页
        if (pageModel > $scope.totalItems / $scope.itemsPerPage) {
          pageModel = Math.ceil($scope.totalItems / $scope.itemsPerPage)
        }
        $scope.ngModel = Number(pageModel)
        setTimeout(() => {
          $scope.ngChange && $scope.ngChange()
        })
      }
      $scope.pageChange = function pageChange() {
        setTimeout(() => {
          $scope.ngChange && $scope.ngChange()
        })
      }
      $scope.pageSizeChange = function pageSizeChange() {
        $scope.itemsPerPage = $scope.pageAddon.itemsPerPage
        if ($scope.profileType != null) {
          httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
            if (res.data.value) {
              const saveConfig = JSON.parse(res.data.value)
              saveConfig.pageSize = $scope.pageAddon.itemsPerPage
              httpRequest.post_saveUserCustomized({
                profileInfo: JSON.stringify(saveConfig),
                profileType: $scope.profileType,
              })
            } else {
              const saveConfig = {}
              saveConfig.pageSize = $scope.pageAddon.itemsPerPage
              httpRequest.post_saveUserCustomized({
                profileInfo: JSON.stringify(saveConfig),
                profileType: $scope.profileType,
              })
            }
          })
        }
        $scope.pageAddon.pageModel = ''
        $scope.ngModel = 1 // 当只有13条在第2页 每页10条切换到每页20条第2页没有数据 需重置页码
        setTimeout(() => {
          $scope.ngChange && $scope.ngChange()
        })
      }
    //   $scope.handleAction = ()=>{
    //     console.log(1111111111);
    //     $scope.perpageList = [
    //         {
    //           text: '10条',
    //           id: 10,
    //         },
    //         {
    //           text: '20条',
    //           id: 20,
    //         },
    //         {
    //           text: '30条',
    //           id: 30,
    //         },
    //         {
    //           text: '50条',
    //           id: 50,
    //         },
    //         {
    //           text: '100条',
    //           id: 100,
    //         },
    //         {
    //           text: '200条',
    //           id: 200,
    //         },
    //       ]
    //   }
    },
  ],
}))



// WEBPACK FOOTER //
// ./src/components/etPagination/index.js